import React, { useState } from 'react';
import './Accordian.css';

const Accordion = ({ title, children }) => {
  const [active, setActive] = useState(false);

  return (
    <div className="accordion">
      <div className="accordionTitle" onClick={() => setActive(!active)}>
        {active ? <span class="material-icons">expand_more</span> : <span class="material-icons">chevron_right</span>}
        <div>{title}</div>
      </div>
      {active ? <div className="accordionContent">{children}</div> : null}
    </div>
  );
};

export default Accordion;
